module.exports = __webpack_public_path__ + "img/image21.e27be755.jpg";